import { call, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { SalesReportActionTypes, SalesReportActions } from "../../../actionTypes/sales/reportActionTypes";
import { getConsolidatedActivitySalesReportApi, getCustomerActivitySalesReportApi, getLeadActivitySalesReportApi, getUserActivitySalesReportApi } from "../../requests/sales/salesReportRequests";


function* getUserActivitySalesReportHandler(action: SalesReportActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getUserActivitySalesReportApi, action.payload);

    if (data.status) {
      window.open(data?.data?.location, "_blank")
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getLeadActivitySalesReportHandler(action: SalesReportActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getLeadActivitySalesReportApi, action.payload);

    if (data.status) {
      window.open(data?.data?.location, "_blank")
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getCustomerActivitySalesReportHandler(action: SalesReportActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getCustomerActivitySalesReportApi, action.payload);

    if (data.status) {
      window.open(data?.data?.location, "_blank")
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getConsolidatedActivitySalesReportHandler(action: SalesReportActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getConsolidatedActivitySalesReportApi, action.payload);

    if (data.status) {
      window.open(data?.data?.location, "_blank")
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

export default function* salesReportSaga() {
  yield takeLatest(SalesReportActions.GET_USER_ACTIVITY_REPORT, getUserActivitySalesReportHandler);
  yield takeLatest(SalesReportActions.GET_LEAD_ACTIVITY_REPORT, getLeadActivitySalesReportHandler);
  yield takeLatest(SalesReportActions.GET_CUSTOMER_ACTIVITY_REPORT, getCustomerActivitySalesReportHandler);
  yield takeLatest(SalesReportActions.GET_CONSOLIDATED_ACTIVITY_REPORT, getConsolidatedActivitySalesReportHandler);
}
